import { ExamAnalysis } from './ExamAnalysis';
export default ExamAnalysis;
